import { Base, createApp } from '@studiometa/js-toolkit';
import { Action } from '@studiometa/ui';
import Accordion from './Accordion.js';
import Slider from './Slider.js';
import MapboxMap from './MapboxMap.js';
import StorePanel from './StorePanel.js';
import StoreOpeningStatus from './StoreOpeningStatus.js';
import StoreResultsList from './StoreResultsList.js';
import StoreFilterBar from './StoreFilterBar.js';
import MobileMapPeek from './MobileMapPeek.js';
import StoreDistanceBadge from './StoreDistanceBadge.js';

/**
 * App
 */
class App extends Base {
  static config = {
    name: 'App',
    debug: true,
    log: true,
    components: {
      Accordion,
      MapboxMap,
      Action,
      StorePanel,
      Slider,
      StoreOpeningStatus,
      // Chantier store-locator-revendeurs, point 4 : composant top-level
      // (jamais un enfant de MapboxMap) pour rester autonome du chargement de
      // la carte (invariant R9) — voir StoreResultsList.js.
      StoreResultsList,
      // Chantier store-locator-revendeurs, point 6 : remplace FilterPanel
      // (panneau modal retiré de « Nos revendeurs ») et ListMapSwitch
      // (bascule Liste/Carte retirée, remplacée par l'aperçu de carte
      // mobile) — voir StoreFilterBar.js et MobileMapPeek.js.
      StoreFilterBar,
      MobileMapPeek,
      // Chantier store-locator-revendeurs, point 7 : page magasin refondue —
      // distance conditionnelle (sessionStorage). Le bouton de démonstration
      // local (StoreDemoButton) a été retiré (retours de Robin du 28/09,
      // critère 14 modifié).
      StoreDistanceBadge,
    },
  };
}

createApp(App, {
  features: {
    asyncChildren: true,
  },
});
